import "whatwg-fetch";

import Action from "../action/Action.ts";

const BookAction = {
    getUnPaidList(token: string, callback: (data: unknown) => void, errorHandler: (error: unknown) => void) {
        const path = "/admin/books/unpaid";
        const header = new Headers();
        const body = null;
        Action.fetchAuthorizedJson(path, token, "GET", header, body, callback, errorHandler);
    },
    getPaidAndDeletedList(token: string, callback: (data: unknown) => void, errorHandler: (error: unknown) => void) {
        const path = "/admin/books/deleted/paid";
        const header = new Headers();
        const body = null;
        Action.fetchAuthorizedJson(path, token, "GET", header, body, callback, errorHandler);
    },
    getNoPlanList(token: string, callback: (data: unknown) => void, errorHandler: (error: unknown) => void) {
        const path = "/admin/books/noplan";
        const header = new Headers();
        const body = null;
        Action.fetchAuthorizedJson(path, token, "GET", header, body, callback, errorHandler);
    },
    getUnSyncList(token: string, callback: (data: unknown) => void, errorHandler: (error: unknown) => void) {
        const path = "/admin/books/unsync";
        const header = new Headers();
        const body = null;
        Action.fetchAuthorizedJson(path, token, "GET", header, body, callback, errorHandler);
    },
    update(token: string, id: string, is_sync: Boolean, callback: (data: unknown) => void, errorHandler: (error: unknown) => void) {
        const path = "/admin/books/" + id + "/sync/status";
        const header = new Headers();
        header.set("Content-Type", "application/json");
        const obj = {
            sync: is_sync,
        };
        const body = JSON.stringify(obj);
        Action.fetchAuthorizedJson(path, token, "PATCH", header, body, callback, errorHandler);
    },
};

export default BookAction;
